import React, {useState, useRef, FC, useEffect} from "react";
import {
  Container,
  DropDown,
  ImgArrow,
  OptionsWrapper,
  Title
} from './styles'
import ArrowDown from './arrow-down.svg'

type SelectProps = {
  children:any,
  title:string,
  customStyles?:any,
}

const RevealButton:FC<SelectProps> = ({title, children, customStyles}) => {
  const selectRef:any = useRef()
  const [active, setActive] = useState<boolean>(false)

  useEffect(() => {
    const handleClickOutside = (event:MouseEvent) => {
      if (!selectRef.current?.contains(event.target)) {
        setActive(false)
      }
    }
    const handleEscape = (event:KeyboardEvent) => {
      if (event.key === 'Escape') {
        setActive(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [])

  return (
    <Container ref={selectRef}>
      <DropDown
        type="button"
        active={active}
        aria-expanded={active}
        aria-haspopup="true"
        onClick={() => setActive(!active)}
        style={customStyles}
      >
        <Title as="span" active={active}>
          {title}
        </Title>
        <ImgArrow alt="" active={active} src={ArrowDown}/>
      </DropDown>
      <OptionsWrapper active={active} hidden={!active}>
        {children}
      </OptionsWrapper>
    </Container>
  )
}

export default RevealButton
